import * as React from "react";

const IconProdListingsInStock: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="currentColor"><polygon fill="currentColor" points="10.498 1.09 9.954 1.605 4.242 7.015 3.727 7.502 3.211 7.015 .544 4.491 0 3.975 1.031 2.885 1.575 3.401 3.727 5.438 8.923 .516 9.466 0 10.498 1.09" transform="translate(0 .75)"/></svg>;
};

export default React.memo(IconProdListingsInStock);
